import { ThemeProvider } from '@emotion/react';
import type { ReactNode } from 'react';

import { darkTheme } from './dark-theme';

export function AppThemeProvider({ children }: { children: ReactNode }) {
  return <ThemeProvider theme={{ colors: darkTheme }}>{children}</ThemeProvider>;
}
